import BaseWindow from "../core/views/BaseWindow";
import BaseChoosePopup from "./BaseChoosePopup";

class GameOverWin extends BaseChoosePopup
{
    constructor(leftCallback, rightCallback)
    {
        super(leftCallback, rightCallback);
        this.topPadding = 7;
        this.bottomPadding = 9;

        this.create();
    }


    init()
    {
        // let w = this.layout.relWidth(100);
        // let h = this.layout.relHeight(100);
        // let shade = new PIXI.Graphics();
        // shade.beginFill(0, .95);
        // shade.drawRect(0, 0, w, h);
        // shade.endFill();
        // this.addChild(shade);
        // shade.x = shade.width * -.5;
        // shade.y = shade.height * -.5;
        //
        // let bg = [1, 2, 3, 4, 5];
        // for (let i = 0; i < bg.length; i++)
        // {
        //     let part = this.assets.getSprite("cockpit_destroyed_" + bg[i]);
        //     this.layout.propHeightScale(part, 100);
        //     this.addChild(part);
        //     part.x = part.width * -.5;
        //     part.y = part.height * -.5;
        // }

        super.init();

        this.setText("Sorry,\nyour balance is not sufficient to make a bet");
    }


    drawAfterSizing()
    {
        this.drawCoins();
        this.drawButtons("Buy coins", "Back to menu");
    }


    drawCoins()
    {
        this.coins = this.assets.getSprite("game_over_coins");
        this.layout.propHeightScale(this.coins, 20);
        this.addChild(this.coins);
        this.layout.horizontalAlignCenter(this.coins, 0, this.winBg);
        this.coins.y = this.winBg.y - this.coins.height*.5;
    }
}

export default GameOverWin;